import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Card,
  CardContent,
  Typography,
  Divider,
  TableSortLabel,
  TextField,
  useTheme,
  Grid,
  MenuItem,
  Autocomplete,
  List,
  ListItem,
  Button,
} from "@mui/material";
import Icons from "../../Utils/Icons";
import { GET, POST } from "../Generic/CrudRequest";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import ModalGeneric from "../Generic/ModalGeneric";
import dayjs from "dayjs";
import moment from "moment";
import utc from "dayjs/plugin/utc";
import { searchPermissions } from "../Users/PermissionsUser/PermissionsActions";
import useExcelExport from "../../Utils/useExcelExport";
import { SaveAlt } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

export default function Loads(props) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [rows, setRows] = React.useState([]);
  const [orderBy, setOrderBy] = React.useState("");
  const [column, setColumn] = React.useState(0);
  const [order, setOrder] = React.useState("asc");
  const [totalRecords, setTotalRecords] = React.useState(0);
  const [searchIdCarga, setSearchIdCarga] = useState("");
  const [searchCarga, setSearchCarga] = useState("");
  const [searchVin, setSearchVin] = useState("");
  const [locations, setLocations] = useState([]);
  const [estatus, setEstatus] = React.useState(true);
  const [idUbicacion, setIdUbicacion] = useState(0);
  const [fecha, setFecha] = useState(dayjs(new Date()));
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalDescription, setModalDescription] = useState("");
  const [bodyModal, setBodyModal] = useState(null);
  const [register, setRegister] = useState(false);
  const [edit, setEdit] = useState(false);
  const [importLoads, setImportLoads] = useState(false);
  const [detail, setDetail] = useState(false);
  dayjs.extend(utc);
  const exportToExcel = useExcelExport();
  const { t } = useTranslation();

  const columns = [
    { id: "noCarga", label: t("loads.table.load"), minWidth: "100px" },
    { id: "numeroEconomico", label: t("loads.table.madrina"), minWidth: "100px" },
    { id: "numeroUnidades", label: t("loads.table.numberUnits"), minWidth: "100px" },
    { id: "estatus", label: t("loads.table.status"), minWidth: "100px" },
    { id: "ubicacion", label: t("loads.table.location"), minWidth: "100px" },
    { id: "fechaRegistro", label: t("loads.table.creationDate"), minWidth: "100px" },
    { id: "unidades", label: t("loads.table.units"), minWidth: "100px" },
  ];
  
  const handleExport = () => {
    exportToExcel(rows, columns, t("loads.excelTitle"));
  };
  const theme = useTheme();
  const { config } = props;

  useEffect(() => {
    fetchCarriers();
  }, [page, rowsPerPage, column, order]);

  const fetchCarriers = async () => {
    const vinsSeparated = searchVin.split(/[,\s]+/);
    const filteredVins = vinsSeparated.filter((vin) => vin.trim() !== "");

    const queryParams = new URLSearchParams({
      start: page * rowsPerPage,
      length: rowsPerPage,
      noCarga: searchCarga,
      idCarga: searchIdCarga,
      estatus: estatus,
      idUbicacion: idUbicacion,
      fecha: fecha.format("MM-DD-YYYY HH:mm:ss"),
      column: column,
      dir: order,
    });

    const dataCarriers = await POST(
      `${config.url}/api/Carriers/paginado?${queryParams.toString()}`,
      filteredVins
    );

    setRows(dataCarriers.resultado);
    setTotalRecords(dataCarriers.totalRegistros);

    const permissionsArray = JSON.parse(localStorage.getItem("permissions"));

    const permissionRegister = searchPermissions(
      "Cargas",
      "Registrar",
      permissionsArray
    );

    const permissionEdit = searchPermissions(
      "Cargas",
      "Editar",
      permissionsArray
    );

    const permissionImportLoads = searchPermissions(
      "Cargas",
      "ImportarCargas",
      permissionsArray
    );

    const permissionDetails = searchPermissions(
      "Cargas",
      "Detalle",
      permissionsArray
    );

    setRegister(permissionRegister);
    setEdit(permissionEdit);
    setImportLoads(permissionImportLoads);
    setDetail(permissionDetails);
  };

  const fetchLocations = async (location, currentPage, perPage) => {
    const dataLocations = await GET(`${config.url}/api/Location/select`, {
      busqueda: location,
      page: currentPage,
      perPage: perPage,
    });

    setLocations(dataLocations.result);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleRequestSort = (property, columnNumber) => {
    const isAsc = orderBy === property && order === "asc";
    setColumn(columnNumber);
    setOrderBy(property);
    setOrder(isAsc ? "desc" : "asc");
  };

  const handleSearch = () => {
    fetchCarriers();
  };

  const handleClear = () => {
    setSearchIdCarga("");
    setSearchCarga("");
    setEstatus(true);
    setIdUbicacion(0);
    setLocations([]);
    setSearchVin("");
    setFecha(dayjs(new Date()));
  };

  const handleChangeEstatus = (event) => {
    setEstatus(event.target.value);
  };

  const handleInputChange = (event, value) => {
    if (value.trim().length >= 3) {
      fetchLocations(value, 1, 10);
    } else {
      setLocations([]);
    }
  };

  const handleModalVins = () => {
    setIsModalOpen(true);
    setModalTitle(t("loads.modal.searchVins.title"));
    setModalDescription(t("loads.modal.searchVins.description"));
    setBodyModal(
      <>
        <Divider sx={{ maxWidth: "100%", margin: "auto", marginTop: 2 }} />
        <Grid container spacing={2} marginTop={1}>
          <Grid item xs={12}>
            <TextField type="text" fullWidth id="modalTextField" />
          </Grid>
        </Grid>
      </>
    );
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleAcceptModal = () => {
    const textFieldValue = document.getElementById("modalTextField").value;
    const vinsString = textFieldValue.replace(/\s+/g, " ").trim();
    setSearchVin(vinsString);

    handleCloseModal();
  };

  const handleChangeVin = (vin) => {
    setSearchVin(vin);
  };

  return (
    <Card
      variant="outlined"
      sx={{
        overflow: "hidden",
        boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
        border: "1px solid rgba(0, 0, 0, 0.1)",
        borderRadius: 2,
      }}
    >
      {isModalOpen && (
        <ModalGeneric
          open={isModalOpen}
          title={modalTitle}
          description={modalDescription}
          onClose={handleCloseModal}
          onAccept={handleAcceptModal}
          bodyComponent={bodyModal}
        />
      )}
      <CardContent>
        <CardContent
          sx={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            justifyContent: "space-between",
            overflow: "hidden",
            maxWidth: "100%",
          }}
        >
          <Typography variant="h3" sx={{ flex: "1", fontWeight: "bold" }}>
            {t("loads.title")}
          </Typography>
          {importLoads && (
            <Link
              to="/Cargas/ImportarCargas"
              style={{ textDecoration: "none" }}
            >
              <Button variant="contained">{t("loads.actions.importLoads")}</Button>
            </Link>
          )}
          {register && (
            <Icons
              iconName="Add"
              fontSize="large"
              to="/Cargas/Agregar"
              style={{
                marginLeft: "15px",
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.white.main,
              }}
              tooltip={t("loads.actions.add")}
            />
          )}
        </CardContent>
        <Divider sx={{ maxWidth: "calc(100% - 32px)", margin: "auto" }} />
        <CardContent
          sx={{
            maxWidth: "calc(100% - 32px)",
            margin: "auto",
            alignItems: "auto",
          }}
        >
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={3}>
              <TextField
                label={t("loads.search.load")}
                type="search"
                InputLabelProps={{
                  shrink: true,
                }}
                variant="standard"
                value={searchCarga}
                onChange={(e) => setSearchCarga(e.target.value)}
                sx={{
                  width: 400,
                  maxWidth: "100%",
                  color: theme.palette.primary.main,
                }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                label={t("loads.search.vin")}
                type="text"
                InputLabelProps={{
                  shrink: true,
                }}
                variant="standard"
                value={searchVin}
                onChange={(e) => handleChangeVin(e.target.value)}
                sx={{
                  width: 400,
                  maxWidth: "100%",
                  color: theme.palette.primary.main,
                }}
                InputProps={{
                  endAdornment: (
                    <Icons
                      iconName="Add"
                      fontSize="small"
                      onClick={() => handleModalVins()}
                      style={{
                        color: theme.palette.primary.main,
                      }}
                    />
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <Autocomplete
                options={locations}
                noOptionsText={t("noOptions")}
                getOptionLabel={(location) =>
                  `${location.nombre} ${location.descripcion} ${
                    location.ciudad ?? ""
                  } ${location.ubicacionTipo ?? ""}`
                }
                onChange={(event, value) => {
                  if (value) {
                    setIdUbicacion(value.idUbicacion);
                  }
                }}
                isOptionEqualToValue={(option, value) =>
                  option && value && option.idUbicacion === value.idUbicacion
                }
                onInputChange={handleInputChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={t("loads.search.location")}
                    variant="standard"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateTimePicker
                  label={t("loads.search.requestDate")}
                  value={fecha}
                  fullWidth
                  onChange={(newValue) => {
                    setFecha(dayjs(newValue));
                  }}
                  slots={{
                    textField: (params) => (
                      <TextField variant="standard" fullWidth {...params} />
                    ),
                  }}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                select
                label={t("loads.search.status")}
                InputLabelProps={{
                  shrink: true,
                }}
                name="estatus"
                variant="standard"
                value={estatus}
                fullWidth
                onChange={handleChangeEstatus}
              >
                <MenuItem value={true}>{t("loads.status.active")}</MenuItem>
                <MenuItem value={false}>{t("loads.status.inactive")}</MenuItem>
              </TextField>
            </Grid>
            <Icons
              iconName="Search"
              fontSize="large"
              onClick={handleSearch}
              style={{ color: theme.palette.primary.main }}
              tooltip={t("loads.actions.search")}
            />
            <Icons
              iconName="Clear"
              fontSize="large"
              onClick={handleClear}
              style={{ color: theme.palette.primary.main }}
              tooltip={t("loads.actions.clear")}
            />
          </Grid>
        </CardContent>
        <Paper
          sx={{
            maxWidth: "calc(100% - 32px)",
            margin: "auto",
            overflow: "hidden",
            boxShadow: "none",
            border: "none",
          }}
        >
          <TableContainer>
            <Button
              variant="contained"
              startIcon={<SaveAlt />}
              onClick={handleExport}
            >
              {t("loads.actions.exportExcel")}
            </Button>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align="left"
                      style={{ minWidth: column.minWidth, fontWeight: "bold" }}
                    >
                      <TableSortLabel
                        active={orderBy === column.id}
                        direction={orderBy === column.id ? order : "asc"}
                        onClick={() =>
                          handleRequestSort(column.id, columns.indexOf(column))
                        }
                      >
                        {column.label}
                      </TableSortLabel>
                    </TableCell>
                  ))}
                  <TableCell />
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={columns.length + 1} align="center">
                      {t("loads.table.noLoadsAvailable")}
                    </TableCell>
                  </TableRow>
                )}
                {rows.map((row, index) => {
                  return (
                    <TableRow key={index}>
                      {columns.map((column) => (
                        <TableCell key={column.id} align="left">
                          {column.id === "estatus" ? (
                            row.estatus === true ? (
                              t("loads.status.active")
                            ) : (
                              t("loads.status.inactive")
                            )
                          ) : column.id === "unidades" ? (
                            row.unidades.length > 0 ? (
                              <List>
                                {row.unidades.map((unidad, index) => (
                                  <ListItem key={index}>{unidad.vin}</ListItem>
                                ))}
                              </List>
                            ) : (
                              <i>{t("loads.table.notAvailable")}</i>
                            )
                          ) : column.id === "fechaRegistro" ? (
                            row.fechaRegistro !== null ? (
                              <span>
                                {moment
                                  .utc(row.fechaRegistro)
                                  .local()
                                  .format("MM/DD/YYYY HH:mm A")}
                              </span>
                            ) : (
                              <i>{t("loads.table.notAvailable")}</i>
                            )
                          ) : row[column.id] !== null &&
                            row[column.id] !== "" ? (
                            row[column.id]
                          ) : (
                            <i>{t("loads.table.notAvailable")}</i>
                          )}
                        </TableCell>
                      ))}
                      <TableCell align="right">
                        {detail && (
                          <Icons
                            iconName="Ballot"
                            fontSize="medium"
                            style={{
                              backgroundColor: theme.palette.secondary.main,
                              color: "#fff",
                            }}
                            to={`/Cargas/Detalle/${row.idCarga}`}
                            tooltip={t("loads.actions.details")}
                          />
                        )}
                      </TableCell>
                      <TableCell align="right">
                        {edit && (
                          <Icons
                            iconName="Edit"
                            fontSize="medium"
                            style={{
                              backgroundColor: theme.palette.primary.main,
                              color: "#fff",
                              marginLeft: 20,
                            }}
                            to={`/Cargas/Editar/${row.idCarga}`}
                            tooltip={t("loads.actions.edit")}
                          />
                        )}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100, { value: -1, label: t("pagination.all") }]}
            component="div"
            count={totalRecords}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage={t("pagination.labelRowsPerPage")}
            labelDisplayedRows={({ from, to, count }) =>
              t("pagination.displayedRows", { from, to, count })
            }
          />
        </Paper>
      </CardContent>
    </Card>
  );
}
